import React from "react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import nutri1 from "../../assets/Nutri1.jpeg"
import kalasagani from "../../assets/Kala_sagani.jpeg"
import education from "../../assets/eduheroo.jpeg"
import womenempowerment from "../../assets/Women_empowerment.jpeg"

const Hero = () => {
  let textSlideContent = [
    {
      id: 1,
      title:
        "Children are the future of the nation and primary child education is the building block of an educated Community.",
      description: [
        "Join hands with Bhavishya NGO and help a child get a quality education through our “SPONSOR A KID” campaign.",
      ],
      img: education,
    },
    {
      id: 2,
      title: "A community, society, and country prosper when its women and girls are empowered.",
      description: [
        "India still ranks 136 in 145 countries as per the Global Gender Gap Index Report 2022.",
        "Let us pledge to make an environment that promotes women to progress and excel.",
      ],
      img: womenempowerment,
    },
    {
      id: 3,
      title: "For some children, nutrition is a distant dream.",
      description: [
        "India accounts for more than 3 out of 10 stunted children in the world.",
        "Bhavishya NGO is taking small steps towards a Nutritious India through the “Ahaar Sewa” initiative for these children.",
      ],
      img: nutri1,
    },
    {
      id: 4,
      title: "Women reinvest up to 90% of their income back into their children's health and education",
      description: [
        "Through our Kala Sangini and livelihood programs, we have already helped over 500 women turn their skills into livelihoods, creating a brighter future for the entire community.",
      ],
      img: kalasagani,
    },
    {
      id: 4,
      title: "India generates over 1.85 lakh tonnes of waste every day",
      description: [
        "Through our regular plantation drives and our creative Kabad se Jugaad initiative, we turn waste into value and show our community that protecting the Earth is a responsibility we all share",
      ],
      img: "https://ik.imagekit.io/bhavishya/web-final/Programs/plantationdrive/plantation1.jpeg?updatedAt=1739986409459",
    }
  ];

  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 3500,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: false }}
      navigation={false}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper w-full"
    >
      {textSlideContent.map((item) => (
        <SwiperSlide key={item.id}>
          <div className="relative w-full h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] overflow-hidden">

            {/* IMAGE */}
            <img
              src={item.img}
              alt="Hero"
              className="w-full h-full object-cover object-center"
            />

            {/* DARK OVERLAY */}
            <div className="absolute inset-0 bg-black/50"></div>

            {/* TEXT CONTENT */}
            <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-3 sm:px-4 md:px-8 lg:px-12 z-10 space-y-2 sm:space-y-3 md:space-y-4 lg:space-y-6">

              <h1 className="text-base sm:text-xl md:text-3xl lg:text-5xl xl:text-6xl font-semibold leading-tight">
                {item.title}
              </h1>

              {item.description.map((desc, i) => (
                <p
                  key={i}
                  className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl max-w-5xl leading-relaxed"
                >
                  {desc}
                </p>
              ))}
            </div>

            {/* OPTIONAL OVERLAY IMAGE */}
            {/* <div className="absolute top-0 left-0 hidden lg:block z-20">
              <img src={OverlayHeroBg} alt="Overlay" />
            </div> */}

          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Hero;